export const ActionTypes = {
  LOADING: "RETRIEVE_USER_LOADING",
  ERROR: "RETRIEVE_USER_ERROR",
  SUCCESS: "RETRIEVE_USER_SUCCESS",
};
